module.exports = __webpack_public_path__ + "img/shield2.632894d2.png";